import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { AskPredefinedTemplatesEffects } from './predefined-templates/predefined-templates.effects';
import {
  AskPredefinedTemplatesNamespace,
  AskPredefinedTemplatesReducer,
} from './predefined-templates/predefined-templates.store';
import { AskTemplatesEffects } from './templates/templates.effects';
import { AskTemplatesNamespace, AskTemplatesReducer } from './templates/templates.store';

export const templatesStoreProvider = provideState(AskTemplatesNamespace, AskTemplatesReducer);
export const templatesEffectsProvider = provideEffects([AskTemplatesEffects]);

export const predefinedTemplatesStoreProvider = provideState(
  AskPredefinedTemplatesNamespace,
  AskPredefinedTemplatesReducer,
);
export const predefinedTemplatesEffectsProvider = provideEffects([AskPredefinedTemplatesEffects]);
export const provideAskHrTemplatesNgrx = [
  templatesStoreProvider,
  templatesEffectsProvider,
  predefinedTemplatesStoreProvider,
  predefinedTemplatesEffectsProvider,
];

@NgModule({
  imports: [
    StoreModule.forFeature(AskTemplatesNamespace, AskTemplatesReducer),
    StoreModule.forFeature(AskPredefinedTemplatesNamespace, AskPredefinedTemplatesReducer),
    EffectsModule.forFeature([AskTemplatesEffects, AskPredefinedTemplatesEffects]),
  ],
})
export class AskHrTemplatesStoreDataModule {}
